<template>
    <div class="c-post-listings">
        <template v-if="error">
            <div class="c-content">
                <p>Sorry, something went wrong with your search. Please reload the page and try again.</p>
            </div>
        </template>
        <template v-else-if="area === 'works'">
            <nav class="c-search-page__jump-nav">
                <span>Jump to</span>
                <a class="c-link" v-if="worksToDisplay && worksToDisplay.length > 0"  href="#work-results">Plays &amp; Poems <i class="fal fa-angle-down" aria-hidden="true"></i></a>
                <a class="c-link" v-if="query && query.length > 0"  href="#text-results">In the texts <i class="fal fa-angle-down" aria-hidden="true"></i></a>
            </nav>
            
            <h2 class="c-search-page__results-title">Plays &amp; Poems ({{ worksToDisplay.length }}) <span class="c-search-page__anchor" id="work-results"></span></h2>
                <template v-if="loading">
                    <Loader/>
                </template>
                <template v-else-if="worksToDisplay && worksToDisplay.length > 0">
                    <div class="c-search-result c-search-result--work" v-for="(result, index) in worksToDisplay"
                        v-html="result.html" :key="index"></div>
                </template>
            <WorksResults v-if="query && query.length > 0" :query="query" :activeWorks="activeWorks" />
        </template>
        <template v-else>
            <template v-if="loading">
                <Loader/>
            </template>
            <template v-else>
                <template v-if="results && results.length > 0">
                    <div class="c-search-result c-search-result--page-post" v-for="(result, index) in results"
                        v-html="result.html" :key="'results-' + index"></div>
                </template>
                <template v-if="collections && collections.length > 0">
                    <h2 class="c-search-page__results-title">Teaching Collections ({{ totalCollections }})</h2>
                    <div class="c-search-result c-search-result--collection" v-for="(collection, index) in collections"
                        v-html="collection.html" :key="'collections-' + index"></div>
                </template>
                <template v-if="resources && resources.length > 0">
                    <h2 class="c-search-page__results-title">Teaching Resources ({{ totalResources }})</h2>
                    <div class="c-search-result c-search-result--resource" v-for="(resource, index) in resources"
                        v-html="resource.html" :key="'resources-' + index"></div>
                </template>
                <template v-if="events && events.length > 0">
                    <h2 class="c-search-page__results-title">Professional Development ({{ totalEvents }})</h2>
                    <div class="c-search-result c-search-result--event" v-for="(eventResult, index) in events"
                        v-html="eventResult.html" :key="'events-' + index"></div>
                </template>
                <template v-if="totalResults === 0 && !loading && query && query.length > 0">
                    <div class="c-content">
                        <p>Sorry, nothing matched your search. Please try broadening your search term.</p>
                    </div>
                </template>
                <Pagination :current-page="page" :total-pages="totalPages" v-if="totalPages > 1"/>
            </template>
        </template>

    </div>
</template>

<script>
    import 'lodash.debounce'
    import Pagination from "./Pagination"
    import {EventBus} from "../event-bus"
    import Loader from "./Loader";
    import WorksResults from "./WorksResults";


    export default {
        name: "Results",
        components: {
            Pagination,
            Loader,
            WorksResults
        },
        props: ['area'],
        watch: {
            "area": function (area, oldArea) {
                if (area !== oldArea) {
                    this.urlParams.area = area
                    this.resetData()
                    this.fetchResults(this.urlParams)
                }
            }
        },
        data() {
            const urlSearchParams = new URLSearchParams(window.location.search)
            return {
                error: false,
                collections: [],
                resources: [],
                events: [],
                results: [],
                activeWorks: [],
                totalCollections: 0,
                totalResources: 0,
                totalResults: 0,
                page: 1,
                totalPages: 0,
                urlParams: {},
                loading: false,
                query: '',
            }
        },
        computed: {
            worksToDisplay() {
                if (this.area !== 'works') {
                    return
                }
                if (this.activeWorks.length === 0) {
                    EventBus.$emit('update-results-count', this.results.length)
                    return this.results
                }
                let returnResults = this.results.filter((result) => {
                    return this.activeWorks.map(item => item ? item.slug : []).includes(result.post.post_name)
                })
                EventBus.$emit('update-results-count', returnResults.length)
                return returnResults
            }
        },
        mounted() {
            EventBus.$on('update-results', (params) => {
                this.resetPagination()
                this.fetchResults(params)
            })
            EventBus.$on('update-page', (page) => {
                this.updatePage(page)
                this.fetchResults(this.urlParams)
            })
            EventBus.$on('update-active-works', (activeFilters) => {
                if (activeFilters.length > 0) {
                    this.activeWorks = activeFilters.filter((item) => {
                        return item.name === 'work' && item.state
                    }).map((item) => {
                        return this.$works.find((work) => work.slug === item.value) 
                    })
                } else {
                    this.activeWorks = []
                }

            })
            EventBus.$on('cleared-filters', () => {
                this.resetData()
                this.fetchResults(this.urlParams)
            })
        },
        created() {
            this.fetchResults = _.debounce(this.fetchResults, 600)
        },
        methods: {
            resetData() {
                this.collections = []
                this.resources = []
                this.events = []
                this.results = []
                this.activeWorks = []
                this.totalResults = 0
                this.urlParams = this.stripTaxonomyFilters(this.urlParams)
                this.resetPagination()
            },
            beforeRequest() {
                axios.interceptors.request.use((config) => {
                    this.loading = true
                    this.collections = [];
                    this.resources = [];
                    this.events = [];
                    this.results = [];
                    return config
                });
            },
            setResultsData: function (results, response) {
                this.collections = results.collection
                this.resources = results.resource
                this.events = results.event
                this.results = results.all
                this.totalResults = response.data.foundPosts
                this.totalPages = response.data.maxNumberOfPages
                if (results.stats) {
                    this.totalCollections = results.stats.collections
                    this.totalResources = results.stats.resources
                    this.totalEvents = results.stats.events
                } else {
                    this.totalCollections = 0
                    this.totalResources = 0
                    this.totalEvents = 0
                }
            },
            stripTaxonomyFilters(params) {
                let data = {};
                for (const [key, value] of Object.entries(params)) {
                    if (key === 'q' || key === 'area') {
                        data[key] = value
                    }
                }
                return data
            },
            fetchResults(params) {
                this.urlParams = !_.isEmpty(params) ? this.formatParams(params) : {}

                // Don't run a search if no params set
                if (_.isEmpty(this.urlParams)) {
                    this.resetData()
                    return;
                }

                this.query = this.urlParams.q
                
                this.error = false
                
                let requestParams = Object.assign({
                    action: 'basethemeSearchResultsRequest',
                    paged: this.page
                }, this.urlParams)

                requestParams.area = this.area

                this.beforeRequest()

                axios.get(window.wpAjax.url, {
                    params: requestParams
                }).catch(error => {
                    this.error = true
                    console.log('Error', error)
                }).then(response => {
                    let results = response.data.results
                    this.setResultsData(results, response)
                    delete this.urlParams['filter-area']
                    EventBus.$emit('update-stats', {
                        total: this.totalResults,
                        searchTerms: this.urlParams
                    })

                    EventBus.$emit('active-filters', results.activeFilters)

                    this.loading = false

                })
            },
            formatParams(params) {
                let data = {};

                for (const [key, value] of Object.entries(params)) {
                    if (key === 'q' || key === 'area') {
                        data[key] = value
                    } else {
                        let paramKey = key.startsWith('filter-') ? key : 'filter-' + key
                        if (!(paramKey in data)) {
                            data[paramKey] = [];
                        }
                        if (Array.isArray(value)) {
                            value.forEach(element => data[paramKey].push(element))
                        } else {
                            data[paramKey].push(value)
                        }
                    }
                }
                
                return data
            },
            resetPagination() {
                this.page = 1
            },
            updatePage(page) {
                this.page = page
            }
        }

    }
</script>

<style scoped>

</style>
